export const waitForElement = (getElement, isCancelled, schedule = requestAnimationFrame) =>
  new Promise((resolve, reject) => {
    const tick = () => {
      if (isCancelled()) {
        reject(new Error("cancelled"));
        return;
      }
      const element = getElement();
      if (element) {
        resolve(element);
        return;
      }
      schedule(tick);
    };
    tick();
  });
